/**
 * Created by matheusmorett on 10/24/17.
 */
import React, { Component } from 'react';
import "./Checkbox.scss";

export default class Checkbox extends Component {

    static defaultProps = {
      onChange: () => {}
    };

    handleChangeInput(e) {
        if(this.props.readOnly) {

        } else {
            this.props.onChange(e.target.checked);
        }
        
    }

    render() {
        return (
            <div className="label--checkbox">
                <input type="checkbox" readOnly={this.props.readOnly} className="checkbox" checked={this.props.checked} onChange={this.handleChangeInput.bind(this)}/>
                    {this.props.text}
            </div>
        )
    }

}




